export enum ArchiveVolumeFileRule {
  NONE = 'NONE',
  SELECT_SECTION = 'SELECT_SECTION',
  SELECT_MATERIAL_TYPE = 'SELECT_MATERIAL_TYPE',
  SELECT_MATERIAL_MODEL = 'SELECT_MATERIAL_MODEL',
  SELECT_MATERIAL_YEAR = 'SELECT_MATERIAL_YEAR',
  SELECT_WBS = 'SELECT_WBS',
  FULL_FILES = 'FULL_FILES',
  MANUAL_SELECT = 'MANUAL_SELECT',
}

export const ArchiveVolumeFileRuleMap = {
  [ArchiveVolumeFileRule.NONE]: '无',
  [ArchiveVolumeFileRule.SELECT_SECTION]: '选择标段',
  [ArchiveVolumeFileRule.SELECT_MATERIAL_TYPE]: '选择材料类型',
  [ArchiveVolumeFileRule.SELECT_MATERIAL_MODEL]: '选择规格型号',
  [ArchiveVolumeFileRule.SELECT_MATERIAL_YEAR]: '选择年份',
  [ArchiveVolumeFileRule.SELECT_WBS]: '选择WBS',
  [ArchiveVolumeFileRule.FULL_FILES]: '文件库内全部尚未归卷文件',
  [ArchiveVolumeFileRule.MANUAL_SELECT]: '在文件库内手动选择入卷文件',
};
